export const APP_ROUTES = {
  HOME: '/',
  HEALTH: '/health',
  SELECT_PLATFORM: '/select-platform',
  USER_MANAGEMENT: '/user-management',
  FAQS: '/faqs',

  META_COLLAB: '/meta/home',
  META_BRAND_MANAGEMENT: '/meta/brand-management',
  BRAND_PAGE: '/meta/:brandId',
  META_LINK: '/meta/:brandId/link',
  BRAND_PAGE_LANDING_PAGE_NEW: '/meta/:brandId/landing-pages/new',
  NEW_AUDIENCE: '/meta/:brandId/audiences/new',
  VIEW_AUDIENCE: '/meta/:brandId/audiences/:audienceId',
  CLONE_AUDIENCE: '/meta/:brandId/audiences/:audienceId/clone',
  META_FAQS: '/meta/faqs',
  META_BEST_PRACTICES: '/meta/best-practices',

  SHOPPABLE_LINKS: '/shoppable-links/home',
  SHOPPABLE_LINKS_BRAND: '/shoppable-links/:brandId',
  NEW_CAMPAIGN: '/shoppable-links/:brandId/new-campaign',
  SHOPPABLE_FAQS: '/shoppable-links/faqs',
  SHOPPABLE_BEST_PRACTICES: '/shoppable-links/best-practices',
  SHOPPABLE_CAMPAIGN_MANAGEMENT: '/shoppable-links/campaign-management',
}

export const LEGACY_ROUTE_REDIRECTS: Record<string, string> = {
  '/home': APP_ROUTES.META_COLLAB,
  '/best-practices': APP_ROUTES.META_BEST_PRACTICES,
}

// Old Meta URLs carried the brand as ?brandId=&platform= (and ?audienceId=); they now redirect to
// the path form so shared and bookmarked links keep working.
export const LEGACY_META_BRAND_REDIRECTS: Record<string, string> = {
  '/meta-link': APP_ROUTES.META_LINK,
  '/meta/link': APP_ROUTES.META_LINK,
  '/brand-page': APP_ROUTES.BRAND_PAGE,
  '/meta/brand-page': APP_ROUTES.BRAND_PAGE,
  '/brand-page/landing-pages/new': APP_ROUTES.BRAND_PAGE_LANDING_PAGE_NEW,
  '/meta/brand-page/landing-pages/new': APP_ROUTES.BRAND_PAGE_LANDING_PAGE_NEW,
  '/brand-page/new-audience': APP_ROUTES.NEW_AUDIENCE,
  '/meta/brand-page/new-audience': APP_ROUTES.NEW_AUDIENCE,
  '/brand-page/view-audience': APP_ROUTES.VIEW_AUDIENCE,
  '/meta/brand-page/view-audience': APP_ROUTES.VIEW_AUDIENCE,
  '/brand-page/clone-audience': APP_ROUTES.CLONE_AUDIENCE,
  '/meta/brand-page/clone-audience': APP_ROUTES.CLONE_AUDIENCE,
}

const PLATFORM_ROUTES: Record<string, { home: string; faqs: string; bestPractices: string }> = {
  meta: {
    home: APP_ROUTES.META_COLLAB,
    faqs: APP_ROUTES.META_FAQS,
    bestPractices: APP_ROUTES.META_BEST_PRACTICES,
  },
  shoppable: {
    home: APP_ROUTES.SHOPPABLE_LINKS,
    faqs: APP_ROUTES.SHOPPABLE_FAQS,
    bestPractices: APP_ROUTES.SHOPPABLE_BEST_PRACTICES,
  },
}

const PLATFORM_BY_ROOT_SEGMENT: Record<string, string> = {
  meta: 'meta',
  'shoppable-links': 'shoppable',
}

export const getActivePlatformName = (pathname: string): string | null =>
  PLATFORM_BY_ROOT_SEGMENT[pathname.split('/')[1]] ?? null

export const getPlatformRoutes = (platform?: string | null) =>
  platform ? PLATFORM_ROUTES[platform.toLowerCase()] : undefined

export const getPlatformHomeRoute = (platform?: string | null): string =>
  getPlatformRoutes(platform)?.home ?? APP_ROUTES.SELECT_PLATFORM
